
export default function (angularModule) {
  angularModule.controller('InvoiceListCtrl',
    (
      $scope,
      invoiceService,
      $stateParams
    ) => {
      $scope.invoices = []

      $scope.authenticationKey = $stateParams.authenticationKey
      $scope.subscriptionId = $stateParams.subscriptionId

      // noinspection JSUnresolvedVariable
      invoiceService.list($stateParams.authenticationKey, $stateParams.subscriptionId)
        .then(invoices => {
          $scope.invoices = invoices
        })
  })
}
